<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="form">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="93px"
               label-position="right"
               class="demo-ruleForm">
        <el-form-item label="Link名称："
                      prop="name">
          <el-input v-model="ruleForm.name"
                    placeholder="请输入Link名称"
                    style="width: 880px;"></el-input>
        </el-form-item>
        <div class="formBox">
          <div class="formLeft">
            <el-form-item label="Link选择："
                          prop="type">
              <el-select v-model="ruleForm.type"
                         style="width: 360px;"
                         placeholder="请选择">
                <el-option v-for="item in options"
                           :key="item.id"
                           :label="item.title"
                           :value="item.id">
                  <div style="display:flex;align-items: center;">
                    <img :src="item.pictureUrl"
                         style="width:20px;height:20px;margin-right:10px"
                         alt="">
                    <span>{{item.title}}</span>
                  </div>

                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="Link外链："
                          prop="url">
              <el-input v-model="ruleForm.url"
                        placeholder="请输入链接地址"
                        style="width: 360px;"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <div class="xzbtn"
               style="margin-left:280px"
               @click="submitForm">确定</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      storeName: '',
      options: [],
      ruleForm: {
        name: '',
        type: '',
        url: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入Link名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择Link', trigger: 'change' }
        ],
        url: [
          { required: true, message: '请输入链接地址', trigger: 'blur' }
        ],
      }
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.getOptions()
    this.getForm()
  },
  methods: {
    getOptions () {
      this.httphelper.get('/api/CGPExpertApi/GetLinkConfigList').then(res => {
        if (res.code == 200) {
          this.options = res.data
        }
      });
    },
    getForm () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertLinkById', {
        Id: this.$route.query.id
      }).then(res => {
        if (res.code == 200) {
          this.ruleForm.name = res.data.title
          this.ruleForm.type = res.data.l_type
          this.ruleForm.url = res.data.l_Url
        }
      });
    },
    submitForm () {
      if (this.ruleForm.name == '') return this.$message.warning('Link名称不能为空');
      else if (this.ruleForm.type == '') return this.$message.warning('请选择Link');
      else if (this.ruleForm.url == '') return this.$message.warning('Link外链不能为空');
      this.httphelper.post('/api/CGPExpertApi/SaveExpertLink', {
        id: this.$route.query.id,
        expertId: Number(localStorage.getItem('storeId')),
        l_Pid: this.ruleForm.type,
        lurl: this.ruleForm.url,
        title: this.ruleForm.name,
        is_Start: 1,
        type: 2
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('修改link成功');
            this.$router.push({
              name: 'uaLink'
            })
          } else {
            this.$message.error('修改link失败');
          }
        })
    }

  }
};
</script>

<style scoped>
.xzbtn {
    margin-top: 60px;
    margin-left: 375px;
    width: 200px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
}
.formBox {
    display: flex;
    justify-content: space-between;
}
.form {
    margin-top: 30px;
}
</style>